import Vuelidate from "vuelidate";
import VuelidateErrorExtractor from "vuelidate-error-extractor";

export default {
  install: Vue => {
    Vue.use(Vuelidate);
    Vue.use(VuelidateErrorExtractor, {
      i18n: false,
      messages: {
        required: "{attribute} is required",
        email: "Not a valid email",
        minLength: "{attribute} must be at least {min} characters",
        maxLength: "{attribute} cannot be longer than {max} characters"
      }
    });
  }
};
